import { render, staticRenderFns } from "./TemplateProductSpecsModal.vue?vue&type=template&id=3b4df1ce&scoped=true"
import script from "./TemplateProductSpecsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplateProductSpecsModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TemplateProductSpecsModal.vue?vue&type=style&index=0&id=3b4df1ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4df1ce",
  null
  
)

export default component.exports